
import { UntypedFormGroup } from '@angular/forms';
    
export function ConfirmedValidator(controlName: string, matchingControlName: string){
    return (formGroup: UntypedFormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];
        if (matchingControl.errors && !matchingControl.errors.matched) {
            return;
        }
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ matched: true });
        } else {
            matchingControl.setErrors(null);
        }
    }
}